<template>
  <div>
    <table style="width: 100%" class="table table-bordered">
      <thead>
        <tr class="text-center">
          <td style="width: 10%">No</td>
          <td style="width: 40%">Kabupaten/Kota</td>
          <td style="width: 20%">Persentase Keterlibatan</td>
          <td style="width: 30%">Ket</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Baubau</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Bombana</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Busel</td>
          <td class="text-center">92%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Buteng</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>5</td>
          <td>Buton</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>6</td>
          <td>Butur</td>
          <td class="text-center">50%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>7</td>
          <td>Kendari</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>8</td>
          <td>Kolaka</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>9</td>
          <td>Koltim</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>10</td>
          <td>Kolut</td>
          <td class="text-center">0%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>11</td>
          <td>Konawe</td>
          <td class="text-center">73%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>12</td>
          <td>Konkep</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>13</td>
          <td>Konsel</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>14</td>
          <td>Konut</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>15</td>
          <td>Mubar</td>
          <td class="text-center">83%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>16</td>
          <td>Muna</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>17</td>
          <td>Wakatobi</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td colspan="2">Rerata</td>
          <td class="text-center">88.1%</td>
          <td>-</td>
        </tr>
      </tbody>
    </table>
    <div id="tabel_3"></div>
    <div class="text-center h_cetak_1">
      <i>Grafik 3. Keterlibatan Dewan Guru & Komsek</i>
    </div>
    <br>
  </div>
</template>



<script>
const ADD_URL = URL_APP + "api/v1/instrumen_guru/";
import uniqid from "uniqid";

export default {
  name: "monev_instrumen_guru",
  data: function() {
    return {
      ada: "ada"
    };
  },

  methods: {
    tabel_3 : function(){
        var data = google.visualization.arrayToDataTable([
          ['Opening Move', 'Percentage', { role: 'annotation' }],
          ["Baubau", 100, 100],
          ["Bombana", 100, 100],
          ["Busel", 92, 92],
          ["Buteng", 100, 100],
          ["Buton", 100, 100],
          ["Butur", 50, 50],
          ["Kendari", 100, 100],
          ["Kolaka", 100, 100],
          ["Koltim", 100, 100],
          ["Kolut", 0, 0],
          ["Konawe", 73, 73],
          ["Konkep", 100, 100],
          ["Konsel", 100, 100],
          ["Konut", 100, 100],
          ["Mubar", 83, 83],
          ["Muna", 100, 100],
          ["Wakatobi", 100, 100],
      ]);

      var options = {
        title: "KEBERADAAN RKAS DI SEKOLAH",
        bar: {groupWidth: '60%'},
        legend: 'none',
        vAxis: {minValue: 0},
        height:350,
        backgroundColor: '#E4E4E4',
      };

      var chart_div = document.getElementById('tabel_3');
      var chart = new google.visualization.ColumnChart(chart_div);

      // Wait for the chart to finish drawing before calling the getImageURI() method.
      google.visualization.events.addListener(chart, 'ready', function () {
        chart_div.innerHTML = '<img src="' + chart.getImageURI() + '">';
        // console.log(chart_div.innerHTML);
      });

      chart.draw(data, options);
    }
  },

  // =============================================================== METHODS =========================================================================

  mounted() {
    google.charts.load("current", { packages: ["corechart"] });
    google.charts.setOnLoadCallback(this.tabel_3);
  }
};
</script>
